const styles = () => ({
  section: {
    borderBottom: '1px solid rgba(155,173,188,0.30)',
    '&:last-of-type': {
      borderBottom: 'none',
    },
    display: 'flex',
    flexDirection: 'column',
  },

  appContainer: {
    display: 'flex',
    flexDirection: 'column',
    paddingTop: 10,
    paddingBottom: 10,
  },

  app: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    minWidth: 300,
    height: 56,
    cursor: 'pointer',
    padding: '0 16px',

    '&:hover': {
      backgroundColor: '#fafbfc',

      '& $arrow': {
        display: 'block',
      },
    },
  },

  appDetailContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },

  appIcon: {
    display: 'block',
    flex: 'none',
    height: 30,
    width: 30,
    marginLeft: 8,
    marginRight: 14,
    filter:
      'drop-shadow(0 0 1px rgba(155,173,188,.4)) drop-shadow(0 1px 1px rgba(155,173,188,.2))',

    '& g path#hub-icon-top, & g path#hub-icon-right, & g path#mark-icon-top, & g path#mark-icon-right, & path#seg-icon-top, & path#seg-icon-right, & path#sf-icon-top, & path#sf-icon-right': {
      stroke: 'rgba(89, 97, 104, .05)',
      strokeWidth: '0.5px',
    },
  },

  appDetail: {
    display: 'flex',
    flexDirection: 'column',
  },

  appTitle: {
    color: '#596168',
    fontSize: 14,
    fontWeight: 500,
  },

  appLinkText: {
    color: '#9badbc',
    fontSize: 13,
  },

  currentTag: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: 18,
    color: '#ffffff',
    fontSize: 11,
    fontWeight: 600,
    backgroundColor: '#7b8b99',
    borderRadius: 9,
    padding: '0 6px',
  },

  break: {
    margin: 0,
    border: '0.5px solid #F0F4F8',
  },

  arrow: {
    display: 'none',
  },
});

export default styles;
